import React from "react";

import {
  getConvocationCount,
  pluralize,
} from "../utils/convocationsAdmin.utils";

export default function EventIdentity({ event }) {
  const count = getConvocationCount(event);

  return (
    <div className="min-w-0">
      <h2 className="text-[15px] font-semibold leading-5 text-slate-900 dark:text-white">
        {event?.titre || "Événement sans titre"}
      </h2>

      <div className="mt-1.5 flex flex-wrap items-center gap-2">
        <span
          className={`inline-flex rounded-full px-2.5 py-1 text-[11px] font-semibold ${
            count > 0
              ? "bg-blue-50 text-blue-700 dark:bg-blue-500/10 dark:text-blue-300"
              : "bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400"
          }`}
        >
          {count}{" "}
          {pluralize(count, "convocation")}
        </span>
      </div>

      {event?.description && (
        <p className="mt-2 line-clamp-2 text-xs leading-5 text-slate-500 dark:text-slate-400">
          {event.description}
        </p>
      )}
    </div>
  );
}